import React from 'react';
import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const methodColors: Record<string, string> = {
  keyword_max: 'primary', cross: 'info', keyword_docname: 'secondary',
  keyword_max_v2: 'secondary', keyword_text_v2: 'secondary',
  keyword_weak: 'warning', keyword_auto: 'success',
  ml_tfidf: 'dark', target_law_v2: 'danger',
  bert_rubert_tiny2: 'purple', bert_rubert_tiny2_v2: 'purple',
  bert_auto: 'purple', fallback_auto: 'light', fallback_v2: 'light',
  keyword_final: 'primary', target_law: 'danger', target_law_v3: 'danger',
  ml_tfidf_v6: 'dark', tfidf_heuristic: 'dark', ml_tfidf_v2: 'dark', regex: 'danger',
};

const methodLabels: Record<string, string> = {
  keyword_max: 'Keyword MAX', cross: 'Cross', keyword_docname: 'Keyword',
  keyword_max_v2: 'Keyword v2', keyword_text_v2: 'Keyword Text',
  keyword_weak: 'Keyword Weak', keyword_auto: 'Keyword Auto',
  ml_tfidf: 'ML TF-IDF', target_law_v2: 'Target Law',
  bert_rubert_tiny2: 'BERT v1', bert_rubert_tiny2_v2: 'BERT v2',
  bert_auto: 'BERT Auto', fallback_auto: 'Fallback', fallback_v2: 'Fallback v2',
  keyword_final: 'Keyword Final', target_law: 'Target Law', target_law_v3: 'Target Law v3',
  ml_tfidf_v6: 'ML v6', tfidf_heuristic: 'Heuristic', ml_tfidf_v2: 'ML v2', regex: 'Regex',
};

interface TopicBadgeProps {
  topic: {
    code: string;
    name: string;
    confidence?: number;
    match_type?: string;
  };
  showConfidence?: boolean;
  showMethod?: boolean;
  linkToTopic?: boolean;
}

export const TopicBadge: React.FC<TopicBadgeProps> = ({
  topic, showConfidence = false, showMethod = false, linkToTopic = true,
}) => {
  const inner = (
    <Badge
      bg={methodColors[topic.match_type || ''] || 'secondary'}
      className="me-1 mb-1"
      style={{ fontSize: '0.78rem', fontWeight: 500 }}
      title={`${topic.code} | conf: ${((topic.confidence || 0) * 100).toFixed(0)}%`}
    >
      {topic.name}
      {showConfidence && topic.confidence !== undefined && (
        <span className="ms-1 opacity-75">({(topic.confidence * 100).toFixed(0)}%)</span>
      )}
      {showMethod && topic.match_type && (
        <span className="ms-1 opacity-75">&middot; {methodLabels[topic.match_type] || topic.match_type}</span>
      )}
    </Badge>
  );
  if (linkToTopic) return <Link to="/topics" className="text-decoration-none">{inner}</Link>;
  return inner;
};
